import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngxs/store';
import * as moment from 'moment';
import { Subscription } from 'rxjs';
import { TeamleaderCalendarTask } from 'src/app/models/TeamleaderCalendarTask';
import { TeamleaderService } from 'src/app/teamleader/teamleader.service';

import { AddCalendarEvent } from '../teamleader.actions';

@Component({
    selector: 'app-teamleader-add-calendar-task',
    templateUrl: './teamleader-add-calendar-task.component.html',
    styleUrls: ['./teamleader-add-calendar-task.component.scss'],
})
export class TeamleaderAddCalendarTaskComponent implements OnInit, OnDestroy {
    private subscriptions = new Subscription();

    @Input() activityType: any;
    worktypes: any[];
    calendarTaskForm: FormGroup;

    constructor(private formBuilder: FormBuilder, private teamleader: TeamleaderService, public activeModal: NgbActiveModal, private store: Store) {}

    ngOnInit(): void {
        this.subscriptions.add(this.teamleader.getWorkTypes().subscribe((workTypes) => (this.worktypes = workTypes.data)));
        this.calendarTaskForm = this.formBuilder.group({
            title: ['', [Validators.required]],
            description: ['', [Validators.required]],
            activityTypeId: [this.activityType.id, [Validators.required]],
            workTypeId: ['', [Validators.required]],
            startsAt: ['', [Validators.required]],
            endsAt: ['', [Validators.required]],
        });
    }

    AddCalendarMeeting() {
        if (this.calendarTaskForm.valid) {
            const formValue = this.calendarTaskForm.value;
            const task: TeamleaderCalendarTask = {
                title: formValue.title,
                description: formValue.description,
                activity_type_id: formValue.activityTypeId,
                work_type_id: formValue.workTypeId,
                starts_at: moment(formValue.startsAt).format(),
                ends_at: moment(formValue.endsAt).format(),
            };
            this.store.dispatch(new AddCalendarEvent(task, 'task'));
            this.activeModal.close();
        }
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
